var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.frontConfig.isShopSectionEnabled)?_c('HelpShop',{staticClass:"mb-3"}):_vm._e(),_c('HelpProfile',{staticClass:"mb-3"}),_c('HelpOrders',{staticClass:"mb-3"}),_c('HelpOther')],1)}
var staticRenderFns = []

export { render, staticRenderFns }